import React from "react";
import { SelectableCustomersFilterContext } from "./context";

export const useSelectableCustomersFilterContext = () => {
  const context = React.useContext(SelectableCustomersFilterContext);
  if (!context) {
    throw new Error(
      "useSelectableCustomersFilterContext must be used within a SelectableCustomersFilterProvider"
    );
  }
  return context;
};
